module.exports = "<div ui-view=main></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/hr/applicants/applicants.html
// module id = 434
// module chunks = 0